import React from 'react';
import { Navbar } from '../../home/components/Navbar';
import { Footer } from '../../home/components/Footer';

export default function LasVegasPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative h-[70vh] flex items-center justify-center">
        <div className="max-w-7xl mx-auto px-6">
          <div className="max-w-3xl">
            <div className="flex items-center gap-2 mb-4">
              <i className="ri-map-pin-line text-[#FF6B35] text-xl"></i>
              <span className="text-[#FF6B35] text-sm font-semibold tracking-wider uppercase">Service Area</span>
            </div>
            <h1 className="text-5xl lg:text-6xl font-bold text-[#2C2C2C] mb-6">
              Las Vegas Pool Repair &amp; Construction Services
            </h1>
            <p className="text-gray-600 text-lg leading-relaxed mb-8">
              RW Construction Las Vegas LLC is your trusted general contractor serving Las Vegas, Nevada. We specialize in pool repair, pool plaster repair, synthetic grass installation, paver installation, concrete work, landscaping, HVAC services, roofing, and complete home remodeling for residential and commercial properties in Las Vegas.
            </p>
            <div className="flex flex-wrap gap-4">
              <button
                onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
                className="inline-flex items-center gap-2 bg-[#FF6B35] text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-[#E55A2B] transition-colors cursor-pointer whitespace-nowrap shadow-lg"
              >
                <i className="ri-calendar-line text-xl"></i>
                Schedule Appointment
              </button>
            </div>
          </div>
        </div>
        <div className="relative z-10 container mx-auto px-4 text-center text-white">
          <a
            href="tel:7027606213"
            className="inline-flex items-center gap-3 bg-white text-orange-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-50 transition-all shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-fill text-2xl"></i>
            Call 702-760-6213
          </a>
        </div>
      </section>

      {/* Services in Las Vegas */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-[#2C2C2C] mb-12 text-center">
            Our Las Vegas Construction Services
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { icon: 'ri-water-flash-line', title: 'Pool Repair Las Vegas', desc: 'Expert pool repair and pool plaster repair services for Las Vegas homes and businesses' },
              { icon: 'ri-plant-line', title: 'Synthetic Grass Las Vegas', desc: 'Professional synthetic grass installation for beautiful, low-maintenance Las Vegas lawns' },
              { icon: 'ri-road-map-line', title: 'Paver Installation Las Vegas', desc: 'Custom paver installation for driveways, patios, and walkways in Las Vegas' },
              { icon: 'ri-hammer-line', title: 'Concrete Work Las Vegas', desc: 'Quality concrete services including driveways, foundations, and decorative concrete in Las Vegas' },
              { icon: 'ri-home-gear-line', title: 'HVAC Services Las Vegas', desc: 'Complete HVAC installation, repair, and maintenance for Las Vegas properties' },
              { icon: 'ri-building-line', title: 'Roofing Las Vegas', desc: 'Professional roofing installation and repair services for Las Vegas homes and commercial buildings' },
            ].map((service, index) => (
              <div key={index} className="bg-[#F8F6F3] rounded-2xl p-8 hover:shadow-lg transition-shadow">
                <div className="w-14 h-14 bg-[#FF6B35] rounded-full flex items-center justify-center mb-6">
                  <i className={`${service.icon} text-white text-2xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-[#2C2C2C] mb-3">{service.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us for Las Vegas */}
      <section className="py-20 bg-[#F8F6F3]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-[#2C2C2C] mb-6">
                Why Las Vegas Homeowners Choose RW Construction
              </h2>
              <p className="text-gray-600 text-base leading-relaxed mb-8">
                As a licensed and insured general contractor in Las Vegas, Nevada, we bring over 20 years of experience to every project. Our team understands the unique challenges of Las Vegas construction, from the desert climate to local building codes.
              </p>
              <div className="space-y-4">
                {[
                  'Licensed &amp; Insured Las Vegas Contractor',
                  '20+ Years Serving Las Vegas Valley',
                  'Expert Pool Repair &amp; Plaster Services',
                  'Free Estimates for Las Vegas Projects',
                  'Quality Workmanship Guaranteed',
                  'Residential &amp; Commercial Services',
                ].map((item, index) => (
                  <div key={index} className="flex items-center gap-3">
                    <div className="w-6 h-6 bg-[#FF6B35] rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-white text-sm"></i>
                    </div>
                    <span className="text-gray-700 font-medium">{item}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="rounded-2xl overflow-hidden shadow-xl">
              <img
                src="https://public.readdy.ai/ai/img_res/bac7cca536eba3c22fd90be831cb1151.jpg"
                alt="Las Vegas Pool Repair and Construction Services"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Las Vegas Neighborhoods */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-[#2C2C2C] mb-6 text-center">
            Las Vegas Neighborhoods We Serve
          </h2>
          <p className="text-gray-600 text-base text-center max-w-3xl mx-auto mb-12">
            We proudly serve all Las Vegas neighborhoods and surrounding areas including Downtown Las Vegas, The Strip, Arts District, and more.
          </p>
          <div className="grid md:grid-cols-3 lg:grid-cols-4 gap-4">
            {[
              'Downtown Las Vegas',
              'The Strip',
              'Arts District',
              'Fremont East',
              'Symphony Park',
              'Centennial Hills',
              'Lone Mountain',
              'The Lakes',
              'Peccole Ranch',
              'Rancho Bel Air',
              'Winchester',
              'Paradise Palms',
            ].map((neighborhood, index) => (
              <div key={index} className="bg-[#F8F6F3] rounded-lg px-4 py-3 text-center">
                <span className="text-gray-700 font-medium text-sm">{neighborhood}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-orange-500 to-red-500">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Ready to Start Your Las Vegas Project?
          </h2>
          <p className="text-white/80 text-lg mb-8">
            Contact RW Construction Las Vegas LLC today for a free estimate on your pool repair, synthetic grass, paver installation, or any construction project in Las Vegas.
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <button
              onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
              className="inline-flex items-center gap-2 bg-[#FF6B35] text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-[#E55A2B] transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-calendar-line text-xl"></i>
              Schedule Appointment
            </button>
            <a
              href="tel:7027606213"
              className="inline-flex items-center gap-3 bg-white text-orange-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-50 transition-all shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-fill text-2xl"></i>
              Call 702-760-6213 Today
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
